import React from "react";
import { Link } from "react-router-dom";

export const NotFound = () => {
    return (
        <div className="exception-body notfound">
            <img src="assets/layout/images/logo-white.svg" alt="diamond-layout" className="logo" />

            <div className="exception-content">
                <div className="exception-title">No encontrado</div>
                <div className="exception-detail">El recurso solicitado no está disponible.</div>
                <Link to="/">Ir al Dashboard</Link>
            </div>
        </div>
    );
};
